import { PIPELINE } from "../../constants";

const { ADD_OPPO_FORM, ADD_ACCOUNT_FORM } = PIPELINE;

// eslint-disable-next-line import/prefer-default-export
export const prepareFormData = state => {
  if (state) {
    return ADD_OPPO_FORM;
  }

  return [
    ...ADD_ACCOUNT_FORM,
    ...ADD_OPPO_FORM.filter(item => item.name !== "account"),
  ];
};



// WEBPACK FOOTER //
// ./src/components/AddOpportunity/methods.js